import React from "react";
import { ParagraphTextColor } from "utils";
import "./styles.sass";
export const ImageDashboard = ({ oldImage, newImage }) => {
  const getUrlImage = () => {
    try {
      return URL.createObjectURL(newImage);
    } catch (e) {
      return null;
    }
  };
  return (
    <div className="image__dashboard">
      {oldImage && (
        <div className="image__dashboard__item">
          <img alt="Imagen actual" src={oldImage} />
          <ParagraphTextColor>Imagen actual</ParagraphTextColor>
        </div>
      )}
      {newImage && (
        <div className="image__dashboard__item">
          <img alt="Imagen nueva" src={getUrlImage()} />
          <ParagraphTextColor>Imagen nueva</ParagraphTextColor>
        </div>
      )}
    </div>
  );
};
